import Direct from './direct/index.js';
import Indirect from './indirect/index.js';
import Chained from './chained/index.js';
const Providers = {
    Direct,
    Indirect,
    Chained,
};
export default Providers;
